import { render } from "./StopDueDiligence.vue?vue&type=template&id=95c699c8&ts=true"
import script from "./StopDueDiligence.vue?vue&type=script&lang=ts"
export * from "./StopDueDiligence.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\AG\\dev\\d_7\\_work\\54\\s\\AEL.DebidaDiligencia.FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__